import { Controller } from 'stimulus'
import { cloneAbove } from '../../utils/dom_utils'
import { useTargetsWithIds } from '../mixins/useTargetsWithIds'
import { actionParamsFromEvent } from '../../utils/stimulus_utils'

export default class extends Controller {
  static targets = ['template']

  connect() {
    useTargetsWithIds(this, ['template'])
  }

  cloneTemplateAboveAndRemoveSelfElem(event) {
    this.cloneTemplateAbove(event)
    event.currentTarget.remove()
  }

  cloneTemplateAbove(event) {
    const { templateId } = actionParamsFromEvent(this, event)
    const template = this.templateTargetWithId(templateId)
    cloneAbove(template.content, event.currentTarget)
  }
}
